module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "modal"
  }, [_vm._l((_vm.props.bg), function(bg, i) {
    return (_vm.$store.state.modalContent === i) ? _c('div', {
      key: i,
      staticClass: "modal__bg",
      style: ({
        backgroundImage: 'url(' + bg.img + ')'
      })
    }) : _vm._e()
  }), _c('div', {
    staticClass: "modal__upper"
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('Icon', {
    staticClass: "modal__close-icon",
    attrs: {
      "name": "arrow"
    }
  }), _c('span', [_vm._v("Back")])], 1), (_vm.$store.state.modalContent === 0) ? _c('div', {
    staticClass: "modal__content"
  }, [_c('Form')], 1) : _vm._e(), (_vm.$store.state.modalContent === 1) ? _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.patient.title)
    }
  }), _c('div', {
    staticClass: "modal__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.patient.subtitle)
    }
  }), _c('div', {
    staticClass: "modal__patient-forms"
  }, _vm._l((_vm.props.patient.forms), function(form, j) {
    return _c('a', {
      key: j,
      staticClass: "modal__patient-form",
      attrs: {
        "href": form.href,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('Icon', {
      staticClass: "modal__form-icon",
      attrs: {
        "name": "tooth-form"
      }
    }), _c('span', [_vm._v(_vm._s(form.text))])], 1)
  })), _c('div', {
    staticClass: "modal__payments"
  }, [_vm._v("Patient Payments ")]), _vm._m(0), _c('div', {
    staticClass: "modal__appt-cta",
    on: {
      "click": function($event) {
        _vm.showModal(0)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.props.patient.cta))]), _c('Icon', {
    staticClass: "modal__appt-icon",
    attrs: {
      "name": "arrow"
    }
  })], 1)]) : _vm._e()])]), _c('div', {
    staticClass: "modal__lower"
  }, _vm._l((_vm.props.lower), function(item, k) {
    return _c('div', {
      key: k,
      staticClass: "modal__lower-item",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })
  }))], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "modal__pay-btn",
    attrs: {
      "href": "https://bestcardteam.com/Payments?Profile=Ostbyorthoweb",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', [_vm._v("Pay Online")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdaa69e4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal.pug
// module id = 547
// module chunks = 1